import { defineSlotRecipe } from '@chakra-ui/react';
import { listboxAnatomy } from '@chakra-ui/react/anatomy';
import { checkmarkRecipe } from '@theme/recipes/checkmark.recipe';

export const listboxSlotRecipe = defineSlotRecipe({
  className: 'chakra-listbox',
  slots: listboxAnatomy.keys(),
  base: {
    root: {
      width: '100%',
      height: '100%',
      padding: 0,
      paddingLeft: 3,
      overflow: 'hidden',
    },
    content: {
      display: 'flex',
      overflow: 'hidden',
      maxHeight: '100%',
      backgroundColor: 'transparent !important',
      border: 'none',
      borderRadius: 0,
      gap: 0,
      '--listbox-item-padding-x': 0,
    },
    item: {
      _hover: {
        '&&:is(:hover, [data-hover]):not(:disabled, [data-disabled])': {
          backgroundColor: 'neutral.800',
        },
      },
      '&&:is([aria-selected=true], [data-selected])': {
        backgroundColor: 'transparent',
      },
    },
    itemIndicator: checkmarkRecipe.base,
  },
});
